import React, { useEffect, useLayoutEffect, useState } from "react";
type MobilePageTransitionProps = {
  /** True while the transition is covering the page. */
  active: boolean;
  /** Called once the video panel has fully lifted away. */
  onDone: () => void;
};
const transitionVideo = "https://cdn.magicpatterns.com/uploads/i7q1RQJiU3gDvLh1KBnSvP/lv_0_20261009061051.mp4";

/** Longest we'll wait for the video before lifting anyway (e.g. if it can't play). */
const maxVideoWaitMs = 15000;

/**
 * Mobile-only transition shown when leaving the home page.
 * The header stays in place; the video plays in the same spot and size as the home page's
 * entrance video (between the header and footer), then slides up beneath the header to
 * reveal the new page, which has already loaded underneath.
 */
export function MobilePageTransition({
  active,
  onDone
}: MobilePageTransitionProps) {
  const [isLifting, setIsLifting] = useState(false);
  const [headerBottom, setHeaderBottom] = useState(0);
  useLayoutEffect(() => {
    if (!active) {
      return;
    }
    const header = document.querySelector("header");
    setHeaderBottom(header ? Math.max(0, header.getBoundingClientRect().bottom) : 0);
  }, [active]);
  useEffect(() => {
    if (!active) {
      setIsLifting(false);
      return undefined;
    }
    const fallback = window.setTimeout(() => setIsLifting(true), maxVideoWaitMs);
    return () => window.clearTimeout(fallback);
  }, [active]);
  if (!active) {
    return null;
  }
  return <div className="fixed inset-x-0 bottom-0 z-20 overflow-hidden md:hidden" style={{
    top: headerBottom
  }} aria-hidden="true" data-id="element-207" data-mp="rj7tl748h8r5">
      <div className="h-full w-full bg-black" style={{
      transform: isLifting ? "translateY(-100%)" : "translateY(0)",
      transition: "transform 300ms cubic-bezier(0.77, 0, 0.175, 1)"
    }} onTransitionEnd={event => {
      if (event.target === event.currentTarget && isLifting) {
        onDone();
      }
    }} data-id="element-208" data-mp="wjlwybuw3uiu">
        {/* Same layout as the home page's mobile entrance video */}
        <div className="flex min-h-[100dvh] w-full items-center justify-center bg-black" data-id="element-209" data-mp="4hxs9ony3p3g">
          <div className="relative aspect-[940/1672] w-full max-w-[940px] overflow-hidden" data-id="element-210" data-mp="4kaj6rbol9sn">
            <video className="h-full w-full object-fill" src={transitionVideo} autoPlay muted playsInline preload="auto" onEnded={() => setIsLifting(true)} onError={() => setIsLifting(true)} data-id="element-211" data-mp="ifdyaz2bxguo" />
            <button type="button" tabIndex={-1} onClick={() => setIsLifting(true)} className="absolute bottom-[3%] right-[5%] rounded-full border border-white/70 bg-black/45 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-white opacity-80 transition-opacity duration-150 ease-out active:opacity-100" data-id="element-212" data-mp="125pyt98w82np">
              Skip
            </button>
          </div>
        </div>
      </div>
    </div>;
}